module.exports = __webpack_public_path__ + "static/img/presysv74.67cf2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv74.png
// module id = zYb5
// module chunks = 1